import React, { useEffect } from "react";
import CalendarAssorts from "../Assorts";
import useCalendarSale from "../hooks/useCalendarSale";
import "./style/style.scss";
import "./style/oneExercise.scss";
import { Exercise } from "../../../models/Exercise";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import StepIndicator from "./shared/StepIndicator";
import useAssortLimits from "../../Universal/hooks/useAssortLimits";
import getId from "../../../../utils/getId";

interface IProps {
  exercise: Exercise;
  refreshCapacityAfterAddTicket: () => void;
  joinToExerciseByPass: (exerciseIds: string, assignType: boolean, passId: number) => void;
  alertCalendar: string;
}

const CalendarOneExercise: React.FC<IProps> = ({
  exercise,
  refreshCapacityAfterAddTicket,
  joinToExerciseByPass,
  alertCalendar,
}: IProps) => {
  const { t } = useTranslation();
  const { getTicketsByExercise, tickets, ticketAccess, ticketLimit, getDetailsAboutExercise, exerciseDetails } =
    useCalendarSale();
  const { limits, isFallback, isLoading: isLimitsLoading, getLimitForAssort, fetchLimits } = useAssortLimits();

  useEffect(() => {
    getTicketsByExercise(exercise.exerciseGroup, exercise);
    getDetailsAboutExercise(exercise.objectId);
    fetchLimits(`${exercise.objectDb},${exercise.objectId}`);
    //eslint-disable-next-line
  }, []);

  // Oblicz globalLimit na podstawie limitów asortymentowych (analogicznie jak w singleConcert)
  const availableCapacity = exercise.capacity - exercise.reserved;
  const visibleAssortIds = new Set(tickets.map((ticket) => getId(ticket)));

  const hardLimited = limits.filter((limit) => {
    const limitAssortId = getId(limit.assortIds);
    return visibleAssortIds.has(limitAssortId) && limit.maxQuantity !== null && limit.maxQuantity !== 0;
  });

  const limitedRemainingTotal = hardLimited.reduce((sum, limit) => {
    if (limit.remainingQuantity === null || limit.remainingQuantity === undefined) return sum;
    return sum + limit.remainingQuantity;
  }, 0);

  const hasHardLimits = hardLimited.length > 0;
  const shouldFallbackToCapacity = !isFallback && hasHardLimits && limitedRemainingTotal > availableCapacity;

  const globalLimit = isFallback
    ? availableCapacity
    : !hasHardLimits || shouldFallbackToCapacity
      ? availableCapacity
      : Math.min(availableCapacity, limitedRemainingTotal);

  const isDesktop = useMediaQuery("(min-width: 1100px)");

  const limitsProps = {
    getLimitForAssort,
    isFallback,
    isLimitsLoading,
    globalLimitOverride: globalLimit,
    exerciseGroupCompositeId: getId(exercise.exerciseGroup),
  };

  return (
    <>
      {isDesktop ? (
        <div className="calendar-modal-one-exercise box shadow border">
          <CalendarAssorts
            alertCalendar={alertCalendar}
            exerciseDetails={exerciseDetails}
            joinToExerciseByPass={joinToExerciseByPass}
            tickets={tickets}
            ticketAccess={ticketAccess}
            ticketLimit={ticketLimit}
            refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
            {...limitsProps}
          />
        </div>
      ) : (
        <div className="">
          <div className="calendar-modal-steps">
            <StepIndicator number={2} label={t("wybierz_rodzaj_i_ilosc_biletow")} />
          </div>

          <CalendarAssorts
            alertCalendar={alertCalendar}
            exerciseDetails={exerciseDetails}
            joinToExerciseByPass={joinToExerciseByPass}
            tickets={tickets}
            ticketAccess={ticketAccess}
            ticketLimit={ticketLimit}
            refreshCapacityAfterAddTicket={refreshCapacityAfterAddTicket}
            {...limitsProps}
          />
        </div>
      )}
    </>
  );
};

export default CalendarOneExercise;
